import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { Form, Input, Button, message } from 'antd'
import { UserContext } from '../../contexts/user.context.js';
import './resetPassword.scss'
import { ForgotPasswordModal } from '../forgotPasswordModal/forgotPasswordModal.component.js';
import { resetPassword } from '../../services/password.service.js';
import StorageKey from '../../enums/storageKey.enum.js';
import { useSearchParams } from 'react-router-dom';
import { transferFlowToUser } from '../../services/flow.service.js';
const { Item } = Form

export const ResetPassword = () => {
  const [form] = Form.useForm()
  const { id } = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState()
  const [openModal, setOpenModal] = useState()
  const { token, setToken, currentUser, setCurrentUser } = useContext(UserContext)
  const [searchParams] = useSearchParams()

  useEffect(() => {

    const updateFlow = async (flowType, currentStepKey, flowId) => {
      console.log("updateFlow", flowType, currentStepKey, flowId)
      const updatedFlow = await transferFlowToUser(flowId, { newUserId: currentUser?._id })
      if (updatedFlow) {
        const autoNextUrl = `/flow/${updatedFlow.type}/${currentStepKey}/${updatedFlow._id}?autoNext=1`
        window.location.href = autoNextUrl      
        return updatedFlow
      }
    }

    if (token) {
      const redirectPath = searchParams.get('redirect')
      if (redirectPath) {
        // if redirect is flow // transfer the flow to the user
        // TO DO: needs extra checks here
        if (redirectPath.includes('flow')) {
          const [flowType, currentStepKey, flowId] = redirectPath.split(/[/?]/).slice(2)

          if (flowType && currentStepKey && flowId) {
            updateFlow(flowType, currentStepKey, flowId)
          }
        }
        else {
          navigate(redirectPath)
        }
      }
      else {
        navigate('/')
      }
    }
  }, [token, currentUser])

  const onFinish = async () => {
    setIsLoading(true)
    try {
      const response = await resetPassword(id, form.getFieldsValue())
      localStorage.setItem(StorageKey.TOKEN, response.token)
      setToken(response.token)
      setCurrentUser(response.user)
      message.info('Password reset. Logging in...')
    } catch (err) {
      console.error(err)
      message.error('Failed to reset password')
    }
    setIsLoading(false)
  };

  return <div className="reset-password">
    <ForgotPasswordModal
      open={openModal}
      setOpen={setOpenModal}
    />

    <div className="reset-password-form-container">

      <div className="reset-password-form-title">Reset Password</div>
      
      <Form
        form={form}
        onFinish={onFinish}
        layout='vertical'
        className="reset-password-form"
    >
      <Item 
        label="New Password"
        name="password"
        rules={[{ 
          required: true, 
          message: 'Enter password'
        }]}
      >
        <Input placeholder="Enter new password..." type="password" />
      </Item>

      <Item>
        <Button 
          htmlType='submit'
          type="primary" 
          loading={isLoading}
        >
          Reset Password
          </Button>
        </Item>
      </Form>
    </div>
  </div>
}